import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonToolbar,
  Button,
  Panel,
  PageHeader,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Alert
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome'

StartQuestionnaire.propTypes = {
  busy: PropTypes.bool.isRequired,
  start: PropTypes.func.isRequired,
};

export function StartQuestionnaire({ formIsValid, busy, rsaId, start, onRsaIdChange, questionnaireName }) {
  return (
    <div>
      <PageHeader>Questionnaire <small>{questionnaireName}</small></PageHeader>
      <Panel>
        <Alert bsStyle="info">
          <p>
            <strong>To start the questionnaire:</strong>
          </p>
          <ol>
            <li>Make sure your 13 digit South Afican ID number is filled in correctly in the textbox below</li>
            <li>Click the "Start Questionnaire" button</li>
          </ol>
        </Alert>

        <form onSubmit={(event) => {
          event.preventDefault();
          start();
        }}>
          <FormGroup
            controlId="formBasicText"
            validationState={rsaId.touched && rsaId.errorMessage ? 'error' : null}>
            <ControlLabel>Republic of South Africa ID Number:</ControlLabel>
            <FormControl
              type="text"
              value={rsaId.value}
              placeholder="South African ID number"
              onChange={onRsaIdChange}
              disabled={!rsaId.canBeChanged}
            />
            <FormControl.Feedback />
            <HelpBlock>{rsaId.errorMessage}</HelpBlock>
          </FormGroup>
        </form>
      </Panel>
      <ButtonToolbar>
        <Button bsStyle="primary" bsSize="large" onClick={start} disabled={busy || !formIsValid}>
        Start Questionnaire&nbsp;
          {!busy && <FontAwesome name='play' />}
          {busy && <FontAwesome name='spinner' spin />}
        </Button>
      </ButtonToolbar>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/startQuestionnaire/StartQuestionnaire.js